import React from "react";

export const fmtMoney = (v) => {
  if (v == null) return "—";
  if (Math.abs(v) >= 1e12) return `$${(v / 1e12).toFixed(2)}T`;
  if (Math.abs(v) >= 1e9)  return `$${(v / 1e9).toFixed(2)}B`;
  if (Math.abs(v) >= 1e6)  return `$${(v / 1e6).toFixed(2)}M`;
  if (Math.abs(v) >= 1e3)  return `$${(v / 1e3).toFixed(0)}K`;
  return `$${v.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

export const fmtPct = (v) =>
  v == null ? "—" : `${v >= 0 ? "+" : ""}${v.toFixed(2)}%`;

export const fmtNum = (v) =>
  v == null ? "—" : v.toLocaleString(undefined, { maximumFractionDigits: 2 });

// Pct → neon HSL color (red → grey → green)
export const pctColor = (pct) => {
  if (pct == null || isNaN(pct)) return "rgba(160,160,170,0.6)";
  const clamped = Math.max(-4, Math.min(4, pct));
  if (clamped >= 0) {
    const a = 0.18 + (clamped / 4) * 0.55;
    return `rgba(0, 230, 120, ${a})`;
  }
  const a = 0.18 + (Math.abs(clamped) / 4) * 0.55;
  return `rgba(255, 70, 80, ${a})`;
};

export const StatRow = ({ label, value, sub }) => (
  <div className="flex items-baseline justify-between gap-3 py-1.5 border-b border-white/5 last:border-0">
    <span className="text-[11px] uppercase tracking-[0.14em] text-white/55">{label}</span>
    <span className="text-right">
      <span className="text-[12.5px] num text-white/90 font-medium">{value}</span>
      {sub && <span className="text-[10px] text-white/45 ml-1 num">{sub}</span>}
    </span>
  </div>
);

export const QUICK_TICKERS = [
  "SPY", "QQQ", "IWM", "DIA",
  "NVDA", "AAPL", "MSFT", "GOOGL", "AMZN", "META", "TSLA", "AMD",
  "JPM", "BAC", "GS",
  "XOM", "GLD", "TLT", "BTC-USD",
];
